export default {
  "en": {
    "editor_ziggu": {
      "actions": {
        "showLess": "Show less",
        "showMore": "Show more"
      },
      "placeholders": {
        "content": "Start typing..",
        "link": "Type/paste a link"
      }
    }
  }
}